<template>
  <div class="App relative">
    <!-- Custom Cursor -->
    <div
      class="custom-cursor"
      :style="{
        left: cursorPosition.x - 10 + 'px',
        top: cursorPosition.y - 10 + 'px',
      }"
    />
    
    <!-- Particle Background -->
    <div class="fixed inset-0 pointer-events-none overflow-hidden">
      <div
        v-for="i in 20"
        :key="i"
        class="particle"
        :style="{
          left: Math.random() * 100 + '%',
          top: Math.random() * 100 + '%',
          width: Math.random() * 4 + 2 + 'px',
          height: Math.random() * 4 + 2 + 'px',
          animationDelay: Math.random() * 8 + 's',
          animationDuration: Math.random() * 4 + 6 + 's',
        }"
      />
    </div>

    <main
      v-motion
      :initial="{ opacity: 0 }"
      :enter="{ opacity: 1 }"
      :duration="800"
    >
      <SiteHeader />
      <router-view />
      <FooterSection />
    </main>

    <!-- Modals -->
    <ServiceModal 
      :isVisible="serviceModalVisible" 
      :serviceType="selectedServiceType"
      @close="closeServiceModal"
    />
    
    <LearnMoreModal 
      :isVisible="learnMoreModalVisible" 
      :serviceType="selectedLearnMoreType"
      @close="closeLearnMoreModal"
      @request-service="openServiceModalFromLearnMore"
    />
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue'
import SiteHeader from './components/SiteHeader.vue'
import FooterSection from './components/FooterSection.vue'
import ServiceModal from './components/ServiceModal.vue'
import LearnMoreModal from './components/LearnMoreModal.vue'

export default {
  name: 'App',
  components: {
    SiteHeader,
    FooterSection,
    ServiceModal,
    LearnMoreModal
  },
  setup() {
    const cursorPosition = ref({ x: 0, y: 0 })
    const serviceModalVisible = ref(false)
    const learnMoreModalVisible = ref(false)
    const selectedServiceType = ref('')
    const selectedLearnMoreType = ref('')

    const updateCursorPosition = (e) => {
      cursorPosition.value = { x: e.clientX, y: e.clientY }
    }

    const openServiceModal = (serviceType) => {
      selectedServiceType.value = serviceType
      serviceModalVisible.value = true
    }

    const closeServiceModal = () => {
      serviceModalVisible.value = false
    }

    const openLearnMoreModal = (serviceType) => {
      selectedLearnMoreType.value = serviceType
      learnMoreModalVisible.value = true
    }

    const closeLearnMoreModal = () => {
      learnMoreModalVisible.value = false
    }

    const openServiceModalFromLearnMore = (serviceType) => {
      openServiceModal(serviceType)
    }

    onMounted(() => {
      window.addEventListener('mousemove', updateCursorPosition)
      window.addEventListener('openServiceModal', (e) => openServiceModal(e.detail))
      window.addEventListener('openLearnMoreModal', (e) => openLearnMoreModal(e.detail))
    })

    onUnmounted(() => {
      window.removeEventListener('mousemove', updateCursorPosition)
      window.removeEventListener('openServiceModal', (e) => openServiceModal(e.detail))
      window.removeEventListener('openLearnMoreModal', (e) => openLearnMoreModal(e.detail))
    })

    return {
      cursorPosition,
      serviceModalVisible,
      learnMoreModalVisible,
      selectedServiceType,
      selectedLearnMoreType,
      closeServiceModal,
      closeLearnMoreModal,
      openServiceModalFromLearnMore
    }
  }
}
</script>
